exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grpStyle input {\n  height: 40px;\n  border-radius: 7px;\n  padding-left: 6px;\n  width: 200px; }\n\n.grpStyle md-select {\n  width: 161px;\n  padding-left: 30px; }\n\n.iconStyle {\n  text-align: center;\n  padding: 17px 2px 17px 2px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/add-group/add-group.component.scss
// module id = ../../../../../src/app/add-group/add-group.component.scss
// module chunks = main